module.exports = __webpack_public_path__ + "static/scale-model-of-sky-zone-trampoline-park-in-fargo-north-dakota-8126dd4c3d09df2eafa3eb9f052bb873.png";